import HomeLanding from "../components/Home/Hero";
import ContactUs from "../components/ContactUs";
import StayInLoop from "../components/StayInLoop";
import AchieveOutcome from "../components/AchieveOutcome/AchieveOutcome";
import CardSwapSectionComponent from "../components/CardsSwapSection";
import { CardSwapImg1, CardSwapImg2, CardSwapImg3, } from "../constant";
import CardsCrausal from "../components/CardCrausalView";
import HeroServices from "../components/HeroServices";
import WeAreIED from "../components/WeAreIED";
import CustomersAndUsers from "../components/CustomerAndUser";
import HeroAboutVideo from "../components/HeroAboutVideo";
import SaaSExcellence from "../components/SaaSExcellence";
import HorizontalInfiniteScroll from "../components/Home/InfiniteHorizontalScroll";
import CookieConsent from "../components/CookiesContent";
import HoverEffectBox from "../components/Imgeview";
import { Alert, Box, Grid, Snackbar, Typography } from "@mui/material";
import AddressSection from "../components/AddressSection";


const cardData = [
  {
    title: "Operational Resilience",
    description:
      "Strengthen enterprise operations through proactive risk management, streamlined workflows, and greater operational visibility across critical business functions.",
  },
  {
    title: "Sustainability Performance",
    description:
      "Accelerate sustainability goals with unified reporting, performance tracking, regulatory alignment, and measurable environmental impact management.",
  },
  {
    title: "Workforce Excellence",
    description:
      "Enhance workforce productivity and field operations through intelligent monitoring, streamlined processes, and real-time operational awareness.",
  },
];


const cardSwapData = [
  {
    number: '01',
    title: 'EHS, ESG Intelligence',
    description:
      'Centralize compliance, emissions, audits, incidents, carbon accounting, and sustainability reporting in one enterprise platform.',
    image: CardSwapImg1,
  },
  {
    number: '02',
    title: 'Connected Operations',
    description:
      'Monitor machines, assets, utilities, and industrial operations in real time using connected sensors and operational intelligence.',
    image: CardSwapImg2,
  },
  {
    number: '03',
    title: 'Enterprise AI',
    description:
      'Enable Generative AI, Agentic AI, RAG-based knowledge systems, predictive analytics, and intelligent automation across enterprise workflows.',
    image: CardSwapImg3,
  }];

export default function Home() {
  return (
    <>

      <HomeLanding />
      <HorizontalInfiniteScroll />

      <AchieveOutcome
        title={`Driving Measurable Outcomes Through AI-Powered EHS & ESG`}
        subTitle={`Empower safer operations, intelligent compliance, sustainability performance, and enterprise-wide risk visibility through connected digital transformation. Powered by AI-driven industrial intelligence and connected operational insights`}
      />
      <CardSwapSectionComponent
        data={cardSwapData}
        title={`Driving Measurable Business Outcomes`}
        subTitle={`Delivering enterprise outcomes through AI, Industrial IoT, sustainability intelligence, and connected digital operations that enhance safety, efficiency, compliance, productivity, and long-term business sustainability.`}
      />
      <CardsCrausal
        title={`Driving Success Through Connected Innovation`}
        subTitle={`Helping enterprises improve operational resilience, workforce performance, sustainability outcomes, and strategic decision-making across complex industrial environments.`}
        cardData={cardData}
      />
      {/* <HoverEffectBox /> */}
      <HeroServices
        title={`Built for Enterprises That Expect Measurable Results`}
        subTitle={`IENERGY helps industrial organizations improve operational performance, strengthen governance, streamline workflows, and deliver long-term business value through execution-focused enterprise solutions.`}
      />
      <WeAreIED />
      {/* <MediaViewWithNav data={tabsData} aboutIED={true}/> */}
      <HeroAboutVideo isNetzero={true} isProduct={false} />
      <SaaSExcellence />
      <CustomersAndUsers />
      <ContactUs />
      <StayInLoop />
      <CookieConsent />
    </>
  );
}
